const styles = theme => ({
    root: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        position: "fixed",
        top: 0,
        zIndex: 10,
    },

    logo: {
        width: "175px",
        paddingLeft: "30px",
        cursor: "pointer",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5px",
        },
    },

    navigationBar: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        [theme.breakpoints.down("sm")]: {
            marginRight: "5%",
        },
    },

    navigationBarBig: {
        [theme.breakpoints.down("sm")]: {
            visibility: "hidden",
            width: "0px",
        },
    },

    navigationBarSmall: {
        [theme.breakpoints.up("md")]: {
            visibility: "hidden",
            width: "20px",
        },
    },

    languageSelector: {
        display: "flex",
        justifyContent: "center",
        paddingLeft: "20px",
        [theme.breakpoints.down("sm")]: {
            paddingRight: "5px",
            paddingLeft: "0px",
        },
    },

    selector: {
        height: "15px",
    },

    adminFormat: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
        marginRight: "50px"
    },

    adminText: {
        fontSize: "25px",
        fontWeight: "500",
    },

    button: {
    },

    drawer: {
        marginTop: "52px",
    },

    list: {
        marginTop: "52px",
        width: "180px",
    },
});

export default styles